import { ApiTypes, getHostPathGenerator, headerFactory } from '~/networking';

export const getRequestUrl = getHostPathGenerator({ type: ApiTypes.CMS });

export const getHeaders = (secure?: boolean, extraHeaders?: { [key: string]: string } | Headers) =>
    headerFactory({ secure, type: ApiTypes.CMS, headers: extraHeaders });
